angular.module('unergie.main')
.controller('greenEnergyModifModalCtrl', ($scope, $uibModal, $uibModalInstance, AlertManager, ApiUser, BoFeaturesService, AuthService, ErrorCatcher, clusters, organization) => {
    const canHalfGreenEnergy = () => BoFeaturesService.getModuleFeatures('b2gHome').canHalfGreenEnergy.split(',').includes(organization)
    const canFiveStepsGreenEnergy = () => BoFeaturesService.getModuleFeatures('b2gHome').canFiveStepsGreenEnergy.split(',').includes(organization)

    $scope.clusters = _.cloneDeep(clusters)
    $scope.modification = 0
    $scope.modificationFloored = 0

    $scope.ESTIMATED_ANNUAL_CONS = 7.5
    $scope.ESTIMATED_ANNUAL_PRICE = Number(BoFeaturesService.getModuleFeatures('b2gHome').goPrices[organization]) || 0.64

    _.each($scope.clusters, (c) => {
        c.new_energy_type = c.energy_type
    })

    $scope.translateEnergyType = {
        MIX: '0 %',
        HALF: '50 %',
        GREEN: '100 %',
        0: '0 %',
        25: '25 %',
        50: '50 %',
        75: '75 %',
        100: '100 %',
    }

    const getEnergyTypePercent = (value) => {
        switch (value) {
            case 'MIX': return 0
            case 'HALF': return 0.5
            case 'THIRD': return 0.3
            case 'GREEN': return 1
            default: return Number(value) / 100
        }
    }

    $scope.types = _.map([...Array(21).keys()], (index) => ({ id: `${index * 5}`, label: `${index * 5} %` }))

    $scope.computeModification = () => {
        // [ESTIMATED_ANNUAL_CONS * ESTIMATED_ANNUAL_PRICE * Nb de PDL * choix actuel ] - [ESTIMATED_ANNUAL_CONS * ESTIMATED_ANNUAL_PRICE * Nb de PDL * nouveau choix ]
        $scope.modification = 0
        _.each($scope.clusters, (c) => {
            $scope.modification += ($scope.ESTIMATED_ANNUAL_CONS * $scope.ESTIMATED_ANNUAL_PRICE * c.nbPrm * getEnergyTypePercent(c.new_energy_type)) -
                ($scope.ESTIMATED_ANNUAL_CONS * $scope.ESTIMATED_ANNUAL_PRICE * c.nbPrm * getEnergyTypePercent(c.energy_type))
        })
        const precision = Math.abs($scope.modification) < 30 ? 5 : 10
        $scope.modificationFloored = Math.abs((Math.round($scope.modification / precision)) * precision)
    }

    $scope.ok = () => {
        $scope.modifying = true
        const payload = {
            clusters: _.map($scope.clusters, (c) => _.pick(c, ['id', 'brand', 'energy_type', 'new_energy_type'])),
            modification: $scope.modification,
        }
        return ApiUser.massModifyEnergyType({}, payload).$promise
        .then((result) => {
            AlertManager.success(`Demande de mise à jour prise en compte, vous pouvez à tout moment procéder à une nouvelle modification.`, 10000)
            $uibModalInstance.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.modifying = false
        })
    }

    $scope.close = () => $uibModalInstance.dismiss()
})
